import { render, staticRenderFns } from "./detail.vue.vue?vue&type=template&id=0c12985a&scoped=true&"
import script from "./detail.vue.vue?vue&type=script&lang=js&"
export * from "./detail.vue.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue.vue?vue&type=style&index=0&id=0c12985a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c12985a",
  null
  
)

export default component.exports